import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";

export const fetchPracticeLanguages = createAsyncThunk(
  "fetchPracticeLanguages",
  async (practiceId) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/practices/${practiceId}/languages`
    );
    return result;
  }
);

export const fetchPracticeLanguageSuggestions = createAsyncThunk(
  "fetchPracticeLanguageSuggestions",
  async (res) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/languages?query=${res}&view=search`
    );

    return result;
  }
);

export const fetchAddPracticeLanguages = createAsyncThunk(
  "fetchAddPracticeLanguages",

  async ({ practiceId, data }) => {
    const result = await FetchRequestHandler(
      "put",
      `${baseUrl}api/practices/${practiceId}/languages`,
      data
    );

    return result;
  }
);

export const fetchDeletePracticeLanguages = createAsyncThunk(
  "fetchDeletePracticeLanguages",

  async ({ practiceId, languageId }) => {
    const result = await FetchRequestHandler(
      "delete",
      `${baseUrl}api/practices/${practiceId}/languages/${languageId}`
    );

    return result;
  }
);
